/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback component for No connected service list
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { useSelector } from 'react-redux';

import { FeatureNameEnum } from '@/main/modules/role/constants/guard/guardConstants';
import { makeSelectIsFeatureWithVersionEnabled } from '@/main/pages/PageAuth/selectors/authSelectors';

import { Button } from '../../../../components/common';
import { ImgStatusError, StatusStyled } from '../../../../components/common/Block/Img';
import { IPageCashbackControlTranslation } from '../../../../modules/internationalization/types/pages/cashback';
import { CashbackTextStyled } from '../styled/CashbackStyled';

export interface ICashbackControlServiceNoConnected {
    translation: IPageCashbackControlTranslation['statusNoConnectedServices'];
    onClick: () => void;
}

const CashbackControlServiceNoConnected = (props: ICashbackControlServiceNoConnected) => {
    const { onClick, translation } = props;
    const isCashbackV4Enabled = useSelector(makeSelectIsFeatureWithVersionEnabled(FeatureNameEnum.CASHBACK, [4], true));

    return (
        <StatusStyled>
            <ImgStatusError/>
            <CashbackTextStyled className="status__title">
                {isCashbackV4Enabled ? translation.newTitle : translation.title}
            </CashbackTextStyled>
            <CashbackTextStyled className="status__sub-title">
                {translation.text}
            </CashbackTextStyled>
            <Button className="status__btn" onClick={onClick}>{translation.btn}</Button>
        </StatusStyled>
    );
};

export default CashbackControlServiceNoConnected;
